import { TranslateFn } from 'hooks/useTranslate';
import { SharesTitle } from 'types';

export const generateSharesTitlesFilename = (
  sharesTitle: Partial<SharesTitle>,
  t: TranslateFn
) =>
  sharesTitle?.number ? `${t('Title')} #${sharesTitle.number}` : t('Title');

export const generateSharesTitlesFilenameWithCoOwners = (
  sharesTitle: SharesTitle,
  t: TranslateFn
) =>
  sharesTitle?.number
    ? `${t('Title')} #${sharesTitle.number} ${t('withEncumbrances')}`
    : `${t('Title')} ${t('withEncumbrances')}`;
